import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { NotificationProvider } from '../../contexts/NotificationContext';
import { OmnichannelProvider } from '../../contexts/OmnichannelContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export default function PrivateRoute({ children }: PrivateRouteProps) {
  const { isAuthenticated } = useAuthContext();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <NotificationProvider>
      <OmnichannelProvider>{children}</OmnichannelProvider>
    </NotificationProvider>
  );
}
